import queryString from "query-string";

import { ECONTRACT_AGREEMENT } from "constants/actionTypes";

import { getLivestockSaleId } from "lib/navigation";
import { serializeEContractAgreement } from "lib/serializers/eContractAgreements";

import {
  offlineActionCreator,
  offlineSubActionCreator,
  urlCheckAndAddIdAndAction,
} from "./lib";

interface UrlCreatorProps {
  id?: string;
  action?: string;
  changesSince?: number;
  livestockSaleId?: number;
}

const urlCreator = ({
  action,
  changesSince,
  livestockSaleId,
  id,
}: UrlCreatorProps = {}) => {
  return queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction(`/v2/econtract-agreements/`, id, action),
    query: {
      changesSince,
      livestock_sale_id: livestockSaleId,
    },
  });
};

export const EContractAgreementAction = offlineActionCreator(
  ECONTRACT_AGREEMENT,
  serializeEContractAgreement,
  urlCreator,
  true,
);

EContractAgreementAction.generate = offlineSubActionCreator(
  ECONTRACT_AGREEMENT.GENERATE,
  () =>
    urlCreator({
      action: "generate",
      livestockSaleId: getLivestockSaleId(),
    }),
);

export interface EContractAgreementGenerateContractPayload {
  id: string;
}

EContractAgreementAction.generateContract = offlineSubActionCreator(
  ECONTRACT_AGREEMENT.GENERATE_CONTRACT,
  (payload: EContractAgreementGenerateContractPayload) =>
    urlCreator({
      id: payload.id,
      action: "generate_contract",
      livestockSaleId: getLivestockSaleId(),
    }),
);
